import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions, RequestOptionsArgs, ResponseContentType } from '@angular/http';
import { Observable } from 'rxjs/Rx';
import * as moment from 'moment';
import { Router } from '@angular/router';
import { CookieService } from 'ngx-cookie';
import { GenService } from './gen-ser.service';
import { RTCToken, ProductGroup, Product, DrawToken, fileObj } from './misc-classes';
import { HttpParams } from '@angular/common/http';
import { formatDate } from '@angular/common';

@Injectable()
export class DataService{
    private static getSearchSerialNosUrl:string = '/searchserialnos';  
    private static getSearchSONosUrl:string = '/searchsonos';  
    private static getProductGroupInfoUrl:string = '/getprodgrpinfo';  
    private static downloadFileUrl:string = '/downloadrtc';
    private static getUploadDrawFoldUrl:string = '/getDrawingsFold';
    private static getDrawFilesUrl:string = '/getDrawingsFiles';
    private static deleteDrawFilesUrl:string = '/deleteDrawingsFiles';
    
    private _userName:string = '';
    private _userId:string = '';
    public currPageName:string = "";
    public _isAdmin:string = '';
    private _hasUploadAccess:boolean = false;
    private _hasDownloadAccess:boolean = false;
    private _hasDrawUploadAccess:boolean = false;
    private _hasDrawDownloadAccess:boolean = false;
    public successOptions = {
        timeOut: 3000,
        showProgressBar: true,
        pauseOnHover: false,
        clickToClose: true,
        maxLength: 10,
        // position: ["top", "right"]
    };
    public failureOptions = {
        timeOut: 5000,
        showProgressBar: true,
        pauseOnHover: false,
        clickToClose: true,
        maxLength: 10
    };    
    
    public _currentSubMenuId:number = -1;
    

    public isUnitDataLoaded:boolean = true;
    public isUserDataLoaded:boolean = false;

    public isBasicDataLoaded:boolean = false;
    private userProductGroups:Array<ProductGroup> = [];

    
    constructor(private http:Http,private router: Router,private _cookieService:CookieService){
        this.getUserNameCookie();
        this.redirectPortal();
        //this.loadUnitListGen().subscribe((_result: boolean) => {
        //  this.isUnitDataLoaded = _result;
        //});
        //this.initDataDefinitions();
    }
    //properties start
    get userName():string{
        return this._userName;
    }
    get userId():string{
        return this._userId;
    }
    
    get isAdmin():string{
      return this._isAdmin;
    }
    get hasUploadAccess():boolean{
        return this._hasUploadAccess;
    }
    get hasDownloadAccess():boolean{
        return this._hasDownloadAccess;
    }
    get hasDrawUploadAccess():boolean{
        return this._hasDrawUploadAccess;
    }
    get hasDrawDownloadAccess():boolean{
        return this._hasDrawDownloadAccess;
    }

    get downloadProductList():Array<Product>{
        if(this.hasDownloadAccess == false) return [];

        let _productList:Array<Product> = [];
        this.userProductGroups.forEach((_tmpPGrp:ProductGroup) => {
            if(_tmpPGrp.hasDownloadAccess || (this.isAdmin == 'true')){
                _tmpPGrp.products.forEach((_tmpProd:Product) => {
                    if(_tmpProd.isRTCFolderExists){
                        _productList.push(_tmpProd);
                    }
                })
            }
        });
        return _productList;
    }
    get uploadProductList():Array<Product>{
        if(this.hasUploadAccess == false) return [];

        let _productList:Array<Product> = [];
        this.userProductGroups.forEach((_tmpPGrp:ProductGroup) => {
            if(_tmpPGrp.hasUploadAccess || (this.isAdmin == 'true')){
                _tmpPGrp.products.forEach((_tmpProd:Product) => {
                    if(_tmpProd.isRTCFolderExists){
                        _productList.push(_tmpProd);
                    }
                })
            }
        });
        return _productList;
    }

    get uploadDrawFolderList():Array<any>{

        if(this.hasDrawUploadAccess == false) return [];

        let _productList:Array<Product> = [];
        this.userProductGroups.forEach((_tmpPGrp:ProductGroup) => {
            if(_tmpPGrp.hasDrawUploadAccess || (this.isAdmin == 'true')){
                _tmpPGrp.products.forEach((_tmpProd:Product) => {
                    if(_tmpProd.isDrawFolderExists){
                        _productList.push(_tmpProd);
                    }
                })
            }
        });
        return _productList;
    }

    get downloadDrawFolderList():Array<any>{

        if(this.hasDrawDownloadAccess == false) return [];

        let _productList:Array<Product> = [];
        this.userProductGroups.forEach((_tmpPGrp:ProductGroup) => {
            if(_tmpPGrp.hasDrawDownloadAccess || (this.isAdmin == 'true')){
                _tmpPGrp.products.forEach((_tmpProd:Product) => {
                    if(_tmpProd.isDrawFolderExists){
                        _productList.push(_tmpProd);
                    }
                })
            }
        });
        return _productList;
    }
    
    //properties end
    //private functions start
    private getUserNameCookie(){
        var _tmpUserName = this.getCookie('username');
        var _tmpIsAdmin = this.getCookie('isAdmin');
        if(_tmpUserName != '' || _tmpIsAdmin !=''){
            this._userName = decodeURI(_tmpUserName);
            this._isAdmin = decodeURI(_tmpIsAdmin);
        }
        else{  
          if((window.location.href.indexOf("id")>=0)){        
            this._cookieService.put('tmpUrl',window.location.href);
          }
          window.location.href = '/assets/login.html';   
        }
    }
    private redirectPortal(){
      if((window.location.href.indexOf("rurl=")>=0)){
           var link = window.location.href;           
           var tmp = link.split("rurl=");
           if(tmp[1])
           this.router.navigateByUrl(decodeURIComponent(tmp[1]));
      }
      else{
        if(this._cookieService.get('tmpUrl')){
          var _url = this._cookieService.get('tmpUrl');
          this._cookieService.remove('tmpUrl');
          var tmp = _url.split("rurl=");
          if(tmp[1])
          this.router.navigateByUrl(decodeURIComponent(tmp[1]));
        } 
      }
    }
    private getCookie(name: string) {
        let ca: Array<string> = document.cookie.split(';');
        let caLen: number = ca.length;
        let cookieName = `${name}=`;
        let c: string;

        for (let i: number = 0; i < caLen; i += 1) {
            c = ca[i].replace(/^\s+/g, '');
            if (c.indexOf(cookieName) == 0) {
                return c.substring(cookieName.length, c.length);
            }
        }
        return '';
    }
    
    private handleError(error: any) {
        let errMsg = error.message || 'Server error';
        return Promise.reject(errMsg);
    }
    
    
    searchSerialNumbers(_srchManfDate:boolean, _fromDate:number, _toDate:number, 
                        _searchOpt:string, _serialNums:Array<string>, _rtcFolders:Array<string>):Observable<Array<RTCToken>>{
      let _params = {
                      "srchdate":(_srchManfDate ? 1 : 0),
                      "fromdate":_fromDate,
                      "todate":_toDate,
                      "srchopt":_searchOpt,
                      "serialnos":_serialNums,
                      "rtcfolders":_rtcFolders
                    };
      let _subscrb = this.http.post(DataService.getSearchSerialNosUrl, _params)
                      .map((res:Response) =>{ 
                          let respJson = res.json();
                          this.checkAuthentication(respJson);
                          if(respJson.status == "OK"){
                            var list = respJson.data;
                            let _rtcList:Array<RTCToken> = [];

                            list.forEach((_token:any) => {
                                _rtcList.push(new RTCToken(_token.serialNo, _token.relPath, _token.utcTimeToken, _token.productId));
                            });

                            _rtcList.sort((_a:RTCToken,_b:RTCToken) => {
                                if(_a.serialNo > _b.serialNo) return 1;
                                if(_a.serialNo < _b.serialNo) return -1;
                                return 0;
                            })
                            return _rtcList;
                          }
                          return null; 
                      })
                      .catch((error:any) => Observable.throw(error || 'Server error'))
      return _subscrb;
    }

    searchSONumbers(_srchUploadDate: boolean, _fromDate: number, _toDate: number,
        _searchOpt: string, _soNums: Array<string>, _drawFolders: Array<string>): Observable<Array<DrawToken>> {
        let _params = {
            "srchdate": (_srchUploadDate ? 1 : 0),
            "fromdate": _fromDate,
            "todate": _toDate,
            "srchopt": _searchOpt,
            "sonos": _soNums,
            "drawfolders": _drawFolders
        };
        let _subscrb = this.http.post(DataService.getSearchSONosUrl, _params)
            .map((res: Response) => {
                let respJson = res.json();
                this.checkAuthentication(respJson);
                if (respJson.status == "OK") {
                    var list = respJson.data;
                    let _drawList: Array<DrawToken> = [];

                    list.forEach((_token: any) => {
                        _drawList.push(new DrawToken(_token.soNo, _token.relPath, _token.utcTimeToken, _token.productId));
                    });

                    _drawList.sort((_a: DrawToken, _b: DrawToken) => {
                        if (_a.soNo > _b.soNo) return 1;
                        if (_a.soNo < _b.soNo) return -1;
                        return 0;
                    })
                    return _drawList;
                }
                return null;
            })
            .catch((error: any) => Observable.throw(error || 'Server error'))
        return _subscrb;
    }
    private addDay(_dayTime:number):number{
        return _dayTime + (24 * 60 * 60 * 1000);
    }
    
    private checkAuthentication(_body){
        if(_body.status == 407){
            window.location.href = '/assets/login.html';
        }
    }
    //private functions end
    //public functions start
    public mAccess(_mId:string):boolean{
        return true;
    }

    public getProductGroupInfo():Observable<boolean>{
        let _subscrb = this.http.post(DataService.getProductGroupInfoUrl, {})
                      .map((res:Response) =>{ 
                          let respJson = res.json();
                          this.checkAuthentication(respJson);
                          if(respJson.status == "OK"){
                            let _tmpProductGroups:Array<ProductGroup> = [];
                            for(var i = 0; i < respJson.data.length; i++){
                                
                                let _tmpProducts:Array<Product> = [];
                                for(var j = 0; j < respJson.data[i].list.length; j++){
                                    let _item:any = respJson.data[i].list[j];
                                    _tmpProducts.push(new Product(_item.name,_item.plant_code, _item.product_code,
                                                        _item.product_id, _item.drawing_id, _item.order));
                                }

                                _tmpProducts.sort((_a:Product, _b:Product) => {
                                    return _a.order - _b.order;
                                })

                                _tmpProductGroups.push(new ProductGroup(respJson.data[i].id,respJson.data[i].name,
                                    respJson.data[i].icon_ref,respJson.data[i].order,respJson.data[i].upUser,
                                    respJson.data[i].downUser, respJson.data[i].drawUpUser, respJson.data[i].drawDownUser, _tmpProducts));
                                

                                if(respJson.data[i].upUser == true){
                                    this._hasUploadAccess = true;
                                }
                                else{
                                    this._hasUploadAccess = false;
                                }
                                if(respJson.data[i].downUser == true){
                                    this._hasDownloadAccess = true;
                                }
                                else{
                                    this._hasDownloadAccess = false;
                                }
                                if(respJson.data[i].drawUpUser == true){
                                    this._hasDrawUploadAccess = true;
                                }
                                else{
                                    this._hasDrawUploadAccess = false;
                                }
                                if(respJson.data[i].drawDownUser == true){
                                    this._hasDrawDownloadAccess = true;
                                }
                                else{
                                    this._hasDrawDownloadAccess = false;
                                }
                                if(this.isAdmin){
                                    this._hasUploadAccess = true;
                                    this._hasDownloadAccess = true;
                                    this._hasDrawUploadAccess = true;
                                    this._hasDrawDownloadAccess = true;
                                }
                            }
                            this.userProductGroups = _tmpProductGroups;
                          }
                          this.isBasicDataLoaded = true;
                          return null; 
                      })
                      .catch((error:any) => Observable.throw(error || 'Server error'))
      return _subscrb;
    }

    public downloadFile(_relPath:string, _name:string) {
        let url:string;
        url  = DataService.downloadFileUrl + "?relpath=" + _relPath 
                + "&name=" + _name;
        window.open(url);
    }
    public downloadFileContent(_relPath:string, _name:string):Observable<any> {
        let url:string;
        url  = DataService.downloadFileUrl + "?relpath=" + _relPath 
                + "&name=" + _name;
        
        const requestOptions:RequestOptionsArgs = {
            headers: new Headers()
            };
        requestOptions.headers.append('Content-Type', 'application/json');
        requestOptions.responseType = ResponseContentType.ArrayBuffer;

        let _subscribe = this.http.get(url,requestOptions).map((_resp:any) =>{
            return _resp;
        })
        .catch((error:any) => Observable.throw(error || 'Server error'));
        
        return _subscribe;
    }

    public getDrawFolderInfo(_pId:string):Observable<any>{
        let _subscrb = this.http.post(DataService.getUploadDrawFoldUrl, {"productId":_pId})
                      .map((res:Response) =>{ 
                          let respJson = res.json();
                          if(respJson.status == "OK"){
                            var list = respJson.data;
                            return list;
                          }
                          return null; 
                        }).catch((error:any) => Observable.throw(error || 'Server error'))
      return _subscrb;
    }
    
    public getDrawFilesInfo(_pId:string,_soNo:string):Observable<any>{
        let _subscrb = this.http.post(DataService.getDrawFilesUrl, {"productId":_pId,"soNo":_soNo})
                      .map((res:Response) =>{ 
                          let respJson = res.json();
                          if(respJson.status == "OK"){
                            let _tmpfiles:Array<fileObj> = [];
                            for(var i = 0; i < respJson.data.length; i++){
                                let _item:any = respJson.data[i];
                                let _tmpDate:Date = new Date(_item.uploadDateTime);
                                _tmpfiles.push(new fileObj(_item.filepath, _item.fileName, _item.categoryName, formatDate(_tmpDate,'dd-MMM-yyyy', 'en-IN')))
                        }
                            return _tmpfiles;
                          }
                          return null; 
                        }).catch((error:any) => Observable.throw(error || 'Server error'))
      return _subscrb;
    }
    public deleteDrawFilesInfo(_path:string):Observable<any>{
        let _subscrb = this.http.post(DataService.deleteDrawFilesUrl, {"path":_path})
                      .map((res:Response) =>{ 
                          let respJson = res.json();
                          if(respJson.status == "OK"){
                            return respJson;
                        }
                          return null; 
                        }).catch((error:any) => Observable.throw(error || 'Server error'))
      return _subscrb;
    }
    //publis functions end
}
